import bgLogin from './bg-login.jpg';

const WebImage = {
    bgLogin,
};

export default WebImage;
